export class CategoriesTable {
    topManagementCategories = [
        {id: 'actiuni strategice', text: 'Actiuni strategice'},
        {id: 'profitabilitate', text: 'Profitabilitate'},
        {id: 'concurenta', text: 'Concurenta'},
        {id: 'oportunitati de dezvoltare', text: 'Oportunitati de dezvoltare'},
        {id: 'alte', text: 'Alte'},
    ];
}
